import {
  greyColor, maxMobile, primaryFont, primaryHeadingColor, wMedium,
} from 'Utils/utilsStyle';
import React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { isGuest, isGuestfromEmail } from '../../../Utils/UtilityFunctions';

const Wrapper = styled.div`
  display: flex;
  margin-bottom: 20px;
  @media all and (max-width: ${maxMobile}) {
    margin-bottom: 10px;
  }
  &.isGuestUser {
    .badge-side {
     cursor: default !important;
    }
  }
  .badge-side {
    width: 50px;
    height: 50px;
    border-radius: 8px;
    border: 1px solid #E1E1E1;
    cursor: pointer;
    @media all and (max-width: ${maxMobile}) {
      width: 40px;
      height: 40px;
    }
    .logo-img {
     height: 100%;
     width: 100%;
     border-radius: 8px;
    }
  }
  .title-side {
    margin-left: 10px;
    .title-section {
      color: ${primaryHeadingColor};
      font-family: ${primaryFont};
      font-size: 16px;
      font-weight: ${wMedium};
      line-height: 17px;
      letter-spacing: -0.375px;
      margin-bottom: 3px;
      @media all and (max-width: ${maxMobile}) {
        font-size: 12px;
        line-height: 14px;
        margin-bottom: 0px;
      }
    }
    .date-stamp, .location-stamp {
      color: ${greyColor};
      font-family: ${primaryFont};
      font-size: 14px;
      font-style: normal;
      font-weight: ${wMedium};
      line-height: 16px;
      margin-bottom: 3px;
      display: block;
      @media all and (max-width: ${maxMobile}) {
        font-size: 10px;
        line-height: 14px;
        margin-bottom: 0px;
      }
    }
    .location-stamp {
      margin-bottom: 0px;
    }
  }
  
`;

type Props = {
  logo: string,
  title: string,
  date: string,
  location: string,
  onClick: () => void,
  onKeyPress: () => void,
};

const CareerBadge = function CareerBadge(props: Props) {
  const {
    logo, title, date, location, onClick, onKeyPress,
  } = props;
  const isGuestUser = isGuest() || isGuestfromEmail();
  return (
    <Wrapper className={classNames('career-widget', { isGuestUser })}>
      <div className="badge-side" onClick={onClick} onKeyPress={onKeyPress} role="button" tabIndex={0}>
        <img src={logo} alt="logo" className="logo-img" />
      </div>
      <div className="title-side">
        <h6 className="title-section text-truncate-one-line">{title}</h6>
        <span className="date-stamp">{date}</span>
        <span className="location-stamp">{location}</span>
      </div>
    </Wrapper>
  );
};

export default CareerBadge;
